export const environment = {
    ENV: 'development',

    API_URL: 'https://mobibus-dev-gateway.fleetaware.pt',

    keycloakConfig: {
        url: 'https://mobibus-dev-auth.fleetaware.pt'
    }
};
